var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "supervisor_account_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/supervisor_account_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 48C43.72 48 50 41.72 50 34C50 26.28 43.72 20 36 20C28.28 20 22 26.28 22 34C22 41.72 28.28 48 36 48ZM36 28C39.32 28 42 30.68 42 34C42 37.32 39.32 40 36 40C32.68 40 30 37.32 30 34C30 30.68 32.68 28 36 28ZM19.08 68H36.2C36.08 68.64 36 69.32 36 70V76H8V70C8 60.68 26.64 56 36 56C38.24 56 41 56.28 43.92 56.8C41.08 58.72 38.72 61.12 37.36 64.04C37.1401 64.04 36.9102 64.03 36.6803 64.02L36.68 64.02L36.6797 64.02C36.4498 64.01 36.2199 64 36 64C29.88 64 23.04 66 19.08 68ZM66 58C58.64 58 44 62.04 44 70V76H88V70C88 62.04 73.36 58 66 58ZM76 42C76 45.76 73.88 49 70.84 50.72C69.4 51.52 67.76 52 66 52C64.24 52 62.6 51.52 61.16 50.72C58.12 49 56 45.76 56 42C56 36.48 60.48 32 66 32C71.52 32 76 36.48 76 42Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmsicon);
export default __webpack_public_path__ + "static/media/umsicon.0bd804d95d6c1ef89346c1e5b31b488d.svg";
export { ForwardRef as ReactComponent };